import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=52286247&scoped=true&"
import script from "./Statistics.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Statistics.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52286247",
  null
  
)

export default component.exports